import ConfigService from "@/services/ConfigService";
import { isCasinoGamePage } from "@/utils/casinoGamePage";
import { startPromoConfig } from "@/providers/promoConfigQuery";
import { startCasinoData } from "../hooks/casinoDataQuery";
import type { ProductCategoryEnum } from "../types/promo";

const CATEGORIES_WITHOUT_LOTTIE = new Set<string>([
  "MYSTERY_BOX",
  "LIGHTWEIGHT_MYSTERY_BOX",
  "WHEEL_4_SECTION",
  "WHEEL_6_SECTION",
  "WHEEL_8_SECTION",
  "WHEEL_10_SECTION",
  "WHEEL_12_SECTION",
  "WHEEL_14_SECTION",
  "WHEEL_16_SECTION",
  "WHEEL_18_SECTION",
  "WHEEL_20_SECTION",
  "LIGHTWEIGHT_WHEEL_4_SECTION",
  "LIGHTWEIGHT_WHEEL_6_SECTION",
  "LIGHTWEIGHT_WHEEL_8_SECTION",
  "LIGHTWEIGHT_WHEEL_10_SECTION",
  "LIGHTWEIGHT_WHEEL_12_SECTION",
  "LIGHTWEIGHT_WHEEL_14_SECTION",
  "LIGHTWEIGHT_WHEEL_16_SECTION",
  "LIGHTWEIGHT_WHEEL_18_SECTION",
  "LIGHTWEIGHT_WHEEL_20_SECTION",
  "MULTI_WHEEL_4_SECTION",
  "MULTI_WHEEL_6_SECTION",
  "MULTI_WHEEL_8_SECTION",
  "MULTI_WHEEL_10_SECTION",
  "MULTI_WHEEL_12_SECTION",
  "MULTI_WHEEL_14_SECTION",
  "MULTI_WHEEL_16_SECTION",
  "MULTI_WHEEL_18_SECTION",
  "MULTI_WHEEL_20_SECTION",
  "SCRATCH_GAME_3_REWARDS",
  "LIGHTWEIGHT_SCRATCH_GAME_3_REWARDS",
  "CARD_MATCHING_3_REWARDS",
  "CARD_MATCHING_4_REWARDS",
  "LIGHTWEIGHT_CARD_MATCHING_3_REWARDS",
  "LIGHTWEIGHT_CARD_MATCHING_4_REWARDS",
  "PENALTY_RNG",
  "LIGHTWEIGHT_PENALTY_RNG",
] satisfies `${ProductCategoryEnum}`[]);

export const startCasinoGamePage = () => {
  const promoId = ConfigService.getPromoId();
  if (!promoId || !isCasinoGamePage()) return;

  startPromoConfig(promoId);
  // Most games import Lottie, and it is their largest chunk: on a slow connection the game waits
  // for it unless it starts as soon as the promo type is known. Remove once no game imports
  // Lottie statically.
  startCasinoData(promoId)
    .then((promo) =>
      CATEGORIES_WITHOUT_LOTTIE.has(promo?.category) ? undefined : import("lottie-react")
    )
    .catch(() => undefined);
};
